import {buildChartTheme, XYChartTheme} from '@visx/xychart';
import produce from 'immer';

import {
  DEFAULT_AXIS_LINE_STYLE,
  DEFAULT_LABEL_STYLE,
  ROTATED_TICK_LABEL_TO_AXIS,
  TICK_LABEL_TO_AXIS,
} from 'ui-library/charting/internals/utils/Theme';
import {GRAY, GRAY_LIGHT, WHITE} from 'ui-library/Colors';

import {getBottomAxisLabelTranslation, getLeftAxisLabelTranslation} from '../Axis';

const DEFAULT_THEME = buildChartTheme({
  backgroundColor: WHITE,
  colors: [], // We don't use the theme to determine colors
  gridColor: GRAY_LIGHT,
  gridColorDark: GRAY,
  tickLength: TICK_LABEL_TO_AXIS,
  svgLabelSmall: DEFAULT_LABEL_STYLE,
  svgLabelBig: DEFAULT_LABEL_STYLE,
  xAxisLineStyles: DEFAULT_AXIS_LINE_STYLE,
  yAxisLineStyles: DEFAULT_AXIS_LINE_STYLE,
});

/**
 * Compute the theme for a cartesian chart.
 *
 * Uses DEFAULT_THEME, and sets properties on the theme that are only known at runtime.
 */
export default function computeCartesianTheme(
  xTickLabelsRotated: boolean,
  bottomMargin: number,
  longestYTickLabelWidth: number
): XYChartTheme {
  return produce(DEFAULT_THEME, (draftTheme) => {
    if (xTickLabelsRotated) {
      draftTheme.axisStyles.x.bottom.tickLength = ROTATED_TICK_LABEL_TO_AXIS;
    }

    draftTheme.axisStyles.x.bottom.axisLabel = {
      ...draftTheme.axisStyles.x.bottom.axisLabel,
      ...getBottomAxisLabelTranslation(bottomMargin),
    };

    draftTheme.axisStyles.y.left.axisLabel = {
      ...draftTheme.axisStyles.y.left.axisLabel,
      ...getLeftAxisLabelTranslation(longestYTickLabelWidth),
    };
  });
}
